export const options_density_modeFull = "Ond";
export const options_density_modeMedium = "Pnd";
export const options_density_modeCompact = "Qnd";
export const options_density_modeRoomy = "Rnd";
export const options_density_modeCozy = "Snd";
export const options_density_modeLarge = "Tnd";
export const options_density_modeSmall = "Und";
export const options_density_quickSetting_label = "Vnd";
export const ariaStringForDensityQuickSetting = "Wnd";
export const options_messageLineCount_three = "Xnd";
export const options_messageLineCount_one = "Ynd";
export const options_oneoutlook_density_quick_tooltip = "Znd";
export default {options_density_modeFull,options_density_modeMedium,options_density_modeCompact,options_density_modeRoomy,options_density_modeCozy,options_density_modeLarge,options_density_modeSmall,options_density_quickSetting_label,ariaStringForDensityQuickSetting,options_messageLineCount_three,options_messageLineCount_one,options_oneoutlook_density_quick_tooltip};